module.exports = __webpack_public_path__ + "static/media/Apr_2026_3.5496ee8d.webp";